"use client";

import mixpanel from "mixpanel-browser";
let initialized = false;

export function initMixpanel() {
  if (initialized) return;

  const token = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

  // Don't initialize if no token is provided
  if (!token || token.trim() === "") {
    return;
  }

  try {
    mixpanel.init(token, {
      debug: false,
      track_pageview: true,
      persistence: "localStorage",
    });
    initialized = true;
  } catch (error) {
    throw new Error(
      `Mixpanel initialization failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}

export function trackEvent(
  eventName: string,
  properties?: Record<string, any>,
) {
  if (!initialized) return;

  try {
    mixpanel.track(eventName, properties);
  } catch (error) {
    throw new Error(
      `Mixpanel trackEvent failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}

export function identifyUser(userId: string) {
  if (!initialized) return;

  try {
    mixpanel.identify(userId);
  } catch (error) {
    throw new Error(
      `Mixpanel identify failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}

export function aliasUser(userId: string) {
  if (!initialized) return;

  try {
    mixpanel.alias(userId);
  } catch (error) {
    throw new Error(
      `Mixpanel alias failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}

export function getDistinctId(): string | null {
  if (!initialized) return null;

  try {
    return mixpanel.get_distinct_id();
  } catch (error) {
    return null;
  }
}

/**
 * Set user profile properties in Mixpanel.
 * These properties appear in the Users section of Mixpanel.
 * @param properties - User profile properties (email, name, etc.)
 */
export function setUserProperties(properties: Record<string, any>) {
  if (!initialized) return;

  try {
    mixpanel.people.set(properties);
  } catch (error) {
    throw new Error(
      `Mixpanel setUserProperties failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}

export function resetMixpanel() {
  if (!initialized) return;

  try {
    mixpanel.reset();
  } catch (error) {
    throw new Error(
      `Mixpanel reset failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}

export function registerSuperProperties(properties: Record<string, any>) {
  if (!initialized) return;

  try {
    mixpanel.register(properties);
  } catch (error) {
    throw new Error(
      `Mixpanel register failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}

export function unregisterSuperProperties(...keys: string[]) {
  if (!initialized) return;

  try {
    keys.forEach((key) => mixpanel.unregister(key));
  } catch (error) {
    throw new Error(
      `Mixpanel unregister failed: ${error instanceof Error ? error.message : "Unknown error"}`,
    );
  }
}
